import React, { useContext, useEffect, useState } from 'react';

import TicketContext from '@totem/components/ticketing/details/ticketContext';
import Hours from '@totem/components/ui_components/widgets/hours/hours';
import { isNotNull } from '@totem/utilities/common';

const TimeEntryHoursSummary = () => {
  const { ticket } = useContext(TicketContext);
  const [totalHours, setTotalHours] = useState<number>(0);
  const [billableHours, setBillableHours] = useState<number>(0);
  const [unbilledHours, setUnbilledHours] = useState<number>(0);
  const [nonBillableHours, setNonBillableHours] = useState<number>(0);

  useEffect(() => {
    let newTotalHours = 0.0;
    let newBillableHours = 0.0;
    let newUnbilledHours = 0.0;
    let newNonBillableHours = 0.0;

    if (
      isNotNull(ticket) &&
      isNotNull(ticket.ticket) &&
      isNotNull(ticket.ticket.timeEntries)
    ) {
      for (const timeEntry of ticket.ticket.timeEntries) {
        newTotalHours += timeEntry.hoursLogged;
        if (timeEntry.billable) {
          newBillableHours += timeEntry.hoursLogged;

          if (timeEntry.billingId === '') {
            newUnbilledHours += timeEntry.hoursLogged;
          }
        } else {
          newNonBillableHours += timeEntry.hoursLogged;
        }
      }
    }

    setTotalHours(newTotalHours);

    setBillableHours(newBillableHours);

    setUnbilledHours(newUnbilledHours);

    setNonBillableHours(newNonBillableHours);
  }, [ticket]);

  return (
    <div>
      <b>Total Hours:</b> <Hours amount={totalHours} />{' '}
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <b>Billable Hours:</b>{' '}
      <Hours amount={billableHours} />{' '}
      {unbilledHours > 0 && (
        <span style={{ color: 'red' }}>
          {'   ('}
          <Hours amount={unbilledHours} />
          {' unbilled)'}
        </span>
      )}
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <b>Unbillable Hours:</b>{' '}
      <Hours amount={nonBillableHours} />
    </div>
  );
};

export default TimeEntryHoursSummary;
